import type { ReactNode } from "react";
import { BucketBarChart, Card } from "@insights/ui";
import { formatChange } from "../helpers/at-a-glance-format";

export function AtAGlanceMetricCard({
  chartLabel,
  chartPoints,
  change,
  eyebrow,
  formatValue,
  icon,
  supporting,
  title,
  total,
  value,
}: {
  chartLabel: string;
  chartPoints: Array<{ label: string; value: number }>;
  change: number;
  eyebrow: string;
  formatValue: (value: number) => string;
  icon: ReactNode;
  supporting?: ReactNode;
  title: string;
  total: number;
  value: number;
}) {
  const changeTone = change > 0 ? "positive" : change < 0 ? "negative" : "flat";

  return (
    <Card as="section" className="glance-metric-card">
      <div className="glance-metric-heading">
        <span className="glance-metric-icon" aria-hidden="true">
          {icon}
        </span>
        <div>
          <span>{eyebrow}</span>
          <h2>{title}</h2>
        </div>
        <span className={`glance-change glance-change--${changeTone}`}>
          {formatChange(change)}
        </span>
      </div>
      <div className="glance-metric-summary">
        <strong>{formatValue(value)}</strong>
        <span>Total · {formatValue(total)}</span>
      </div>
      {supporting}
      <BucketBarChart
        ariaLabel={chartLabel}
        data={chartPoints}
        formatValue={formatValue}
      />
    </Card>
  );
}
